var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinAgainGoldMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 1.83337C5.93965 1.83337 1.83301 5.94004 1.83301 11C1.83301 16.06 5.93965 20.1667 10.9996 20.1667C16.0596 20.1667 20.1663 16.06 20.1663 11C20.1663 5.94004 16.0596 1.83337 10.9996 1.83337ZM6.04965 10.2942C6.2055 9.20339 6.69135 8.22254 7.45215 7.45254C9.2855 5.62839 12.173 5.52754 14.1346 7.12254V6.25169C14.1346 5.87589 14.4463 5.56419 14.8221 5.56419C15.198 5.56419 15.5096 5.87589 15.5096 6.25169V8.69919C15.5096 9.07504 15.198 9.38669 14.8221 9.38669H12.3746C11.9988 9.38669 11.6871 9.07504 11.6871 8.69919C11.6871 8.32339 11.9988 8.01169 12.3746 8.01169H13.0621C11.6413 7.02169 9.67965 7.15919 8.41465 8.42419C7.86465 8.97419 7.51635 9.68919 7.39715 10.4867C7.35135 10.8259 7.058 11.0734 6.71885 11.0734C6.68215 11.0734 6.65465 11.0734 6.618 11.0642C6.2605 11.0184 5.99465 10.67 6.04965 10.2942ZM14.5471 14.5475C13.5663 15.5284 12.283 16.0142 10.9996 16.0142C9.88135 16.0142 8.77215 15.62 7.8555 14.8775V15.7392C7.8555 16.115 7.54385 16.4267 7.168 16.4267C6.79215 16.4267 6.4805 16.115 6.4805 15.7392V13.2917C6.4805 12.9159 6.79215 12.6042 7.168 12.6042H9.6155C9.99135 12.6042 10.303 12.9159 10.303 13.2917C10.303 13.6675 9.99135 13.9792 9.6155 13.9792H8.928C10.3488 14.9692 12.3105 14.8317 13.5755 13.5667C14.1255 13.0167 14.4738 12.3017 14.593 11.5042C14.648 11.1284 14.9871 10.8625 15.3721 10.9175C15.748 10.9725 16.0046 11.3209 15.9588 11.6967C15.7938 12.8059 15.308 13.7867 14.5471 14.5475Z",
    fill: "url(#paint0_linear_3002_4582)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3002_4582",
    x1: 1.83301,
    y1: 11,
    x2: 20.1663,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B45F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinAgainGoldMini);
export default __webpack_public_path__ + "static/media/spin-again-gold-mini.532d8e2f84a1b0669dea4432247db715.svg";
export { ForwardRef as ReactComponent };